import React, { Component } from 'react';
import './Articles.css';
import Promo from './Promo';

class Article extends Component {
  render(props) {
    const hasPromo = !this.props.article.promo;
    return [
      hasPromo ? <Promo {...this.props.article.promo} /> : null,
      <div className="card article">
        <div className="card-content">
          <div className="media">
            <div className="media-center">
                <img src={this.props.article.author.image} className="author-image" alt="Placeholder image" />
            </div>
            <div className="media-content has-text-centered">
              <p className="title article-title">{this.props.article.title}</p>
              <p className="subtitle is-6 article-subtitle">
                <a href="#">{this.props.article.author.name}</a> on {this.props.article.date} 
              </p>
            </div>
          </div>
          <div className="content article-body">
           {this.props.article.body} 
          </div>
        </div>
      </div>
    ];
  }
}

export default Article;



// WEBPACK FOOTER //
// ./src/components/articles/Article.jsx